import React, { useEffect } from "react";
import Routes from "routes";
import ErrorBoundary from "components/ErrorBoundary";
import ScreenLocker from "components/ScreenLocker";
import { BrowserRouter, useLocation } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { UserDataProvider } from "components/customHooks/userDataContext";
import theme from "styles/mui/theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useDispatch } from "react-redux";
import { setCountryCode, setPracticeTimezone } from "./redux/reducers/practice";
import { getWebVersion } from "apiHandler/actions";
import packageJson from "../package.json";
import semver from "semver";

// Extend dayjs with the plugins
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("America/New_York");

const RouteChangeHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await getWebVersion();
        console.log("data>>>: ", response);
        console.log(
          "New version detected:",
          response.version,
          ">>>",
          packageJson.version,
          ">>>",
          semver.gt(response.version, packageJson.version),
        );

        // Check if the version is different
        if (
          response.version &&
          semver.gt(response.version, packageJson.version)
        ) {
          // Check if reload has already happened
          const lastReloadedVersion = sessionStorage.getItem(
            "lastReloadedVersion",
          );

          if (lastReloadedVersion !== response.version) {
            sessionStorage.setItem("lastReloadedVersion", response.version);
            window.location.reload();
          }
        }
      } catch (error) {
        console.error("Error checking version:", error);
      }
    };

    checkVersion(); // Trigger version check on route change
  }, [location]);

  return null;
};

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const savedTz = localStorage.getItem("practice_timezone");
    const savedCountryCode = localStorage.getItem("country_code");
    if (savedTz) {
      dispatch(setPracticeTimezone(savedTz));
    }
    if (savedCountryCode) {
      dispatch(setCountryCode(savedCountryCode));
    }
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter>
          <ErrorBoundary>
            <UserDataProvider>
              <ScreenLocker>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <RouteChangeHandler />
                  <Routes />
                </MuiPickersUtilsProvider>
              </ScreenLocker>
            </UserDataProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
